import { withFormik } from 'formik';
import { compose, withHandlers } from 'recompose';

const state = {
  Draft: () => true,
  Published: props => (props.dirty && props.isValid) || true,
};

export default ({ afterSubmit, ...opts }) =>
  compose(
    withFormik({
      handleSubmit: (data, { props, ...form }) => {
        props.onSubmit(data, form).then(() => {
          if (afterSubmit) {
            afterSubmit(props);
          }
        });
      },
      ...opts,
    }),
    withHandlers({
      handleChangeStatus: props => status => {
        if (state[status] && state[status](props)) {
          props.setFieldValue('status', status);
          props.setStatus({
            ...props.status,
            changingScheduledStatus: true,
          });

          props.submitForm();
        }
      },
      handleDelete: ({ api, onDeleted = () => {} }) => {
        // eslint-disable-next-line no-underscore-dangle
        if (!api || !api._delete) return null;

        return id => {
          api._delete(id); // eslint-disable-line no-underscore-dangle
          onDeleted();
        };
      },
    })
  );
